import Swal from 'sweetalert2';
export const swal2 = {
  Confirm: {
    title: "Are you sure?",
    text: "You won't be able to revert this!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#ff4b4b",
    showLoaderOnConfirm: true,
    //cancelButtonColor: "#d33",

    confirmButtonText:
      '<i className="fa fa-trash" aria-hidden="true"></i> Yes, Delete it!',
    cancelButtonText:
      '<i className="fa fa-times" aria-hidden="true"></i> No, cancel!',
  },
  success: {
    icon: "success",
    title: "Success",
  },
  error: {
    icon: "error",
    title: "Error",
  },
  warning: {
    icon: "warning",
    title: "Warning",
  },
  info: {
    icon: "info",
    title: "Info",
  },
  question: {
    icon: "question",
    title: "Question",
  },
  Toast: Swal.mixin({
    toast: true,
    text: "",
    position: "top-right",
    customClass: {
      popup: "colored-toast",
    },
    showConfirmButton: false,
    timer: 1500,
    timerProgressBar: true,
  }),

  SwalWithBootstrapButtons: Swal.mixin({
    customClass: {
      confirmButton: "btn btn-danger mx-2 btn-sm",
      cancelButton: "btn btn-light mx-2 btn-sm",
    },
    buttonsStyling: false,
  }),
};